import React from 'react';
import { FormGroup, Modal, Col, Button, Row } from 'react-bootstrap';
import moment from 'moment';
import './style.scss'
import {getWeek, getWeekFromDate} from '../orderUtil'


class OrderConfirmationModal extends React.Component {
    constructor(props) {
        super(props);
        this.renderChanges = this.renderChanges.bind(this);
    }


    renderChanges() {
        let changedOrders = this.props.changedOrders;
        let result = null;
        if (this.props.showModal && changedOrders.length > 0) {
            result = (
                <div>
                    {changedOrders.map((changedRow) => {
                        changedRow.editedValues.sort((a, b) => this.sortEditedValues(a, b))
                        return (
                            <div className="div-main" key={"maindiv"+changedRow.order.ORDER_COMBO}>
                                <b key={'ordersum' + changedRow.order.ORDER_COMBO}>{changedRow.order.ORDER_COMBO} - {changedRow.order.CLIENT_CODE_REGIONAL} - {changedRow.order.SHORT_NAME}</b>
                                <ul>
                                    {changedRow.editedValues.map((editedColumn) => {
                                        return (
                                            <div key={"div"+changedRow.order.ORDER_COMBO + editedColumn.column}>
                                                <li key={"list"+changedRow.order.ORDER_COMBO + editedColumn.column}>
                                                    <Row lg={12}>
                                                        {this.getRowValue(editedColumn, changedRow)}
                                                    </Row>
                                                </li>
                                            </div>

                                        )
                                    })}
                                </ul>
                            </div>

                        )

                    })}
                </div>
            );
        }
        return result;

    }

    sortEditedValues(a, b) {
        if (a.column < b.column) return -1;
        if (a.column > b.column) return 1;
        return 0;
    }

    // getWeek(value) {
    //     if (value && value.length == 2 && parseInt(value) == value && value > 0 && value < 54) {

    //         var year = (new Date().getFullYear()).toString();
    //         return year + ('0' + value).slice(-2);
    //     }
    //     else
    //         return value;
    // }

    // getWeekFromDate(date) {
    //     if (date.length > 0) {
    //         var currentWeekNumber = moment(date, "YYY-MM-DD").isoWeek() + 1;
    //         let value = String(currentWeekNumber).padStart(2, '0');
    //         return this.getWeek(value);
    //     }
    //     return '';

    // }

    getRowValue(changedColumn, row) {
        let output = { header: '', value: '', originalValue: '' };
        let { column, originalValue } = changedColumn;

        switch (column) {
            case 'UNIT_PRICE_COMMITTED':
                output.header = 'Sales price';
                output.value = row.order[column] + ' ' + row.order.CURRENCY_CODE;
                output.originalValue = originalValue + ' ' + row.order.CURRENCY_CODE;
                break;

            case 'EXMILL':
                output.header = column;
                output.value = row.order[column];
                output.originalValue = getWeekFromDate(originalValue);

                break;

            default:
                output.header = column;
                output.value = row.order[column];
                output.originalValue = originalValue;

        }

        //return <span>{output.header + '- New value: ' + output.value + ' - Old value: ' + output.originalValue}</span>

        return (
            <Row>
                <Col lg={3}>
                    <span>{output.header}</span>
                </Col>
                <Col lg={3}>
                    <del>{output.originalValue}</del>
                </Col>
                <Col lg={3}>
                    <span>{output.value}</span>
                </Col>
            </Row>
        )
    }


    render() {
        let buttonProps = {
            type: "button",
            bsStyle: "primary"
        }
        //style={{maxHeight: '100%', overflowY: 'auto'}

        return (
            <Modal key="modalMain" show={this.props.showModal} style={{ maxHeight: '100vh' }}>
                <Modal.Header>
                    <Modal.Title>Confirm order changes</Modal.Title>
                    <span>To re-edit the orders. Click the back button. </span><br />
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '30vh', height: '60%', overflow: 'hidden', overflowY: 'auto' }}>
                    {this.renderChanges()}

                </Modal.Body>
                <Modal.Footer>
                    <FormGroup>
                        <Col>
                            <Button {...buttonProps} onClick={() => this.props.toggleModal(false)}>
                                Back
                            </Button>
                            <Button {...buttonProps} onClick={() => this.props.confirm()}>
                                Confirm
                            </Button>
                        </Col>
                    </FormGroup>
                </Modal.Footer>
            </Modal>
        )
    }
}


export default OrderConfirmationModal;